import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import Button from "components/atoms/Button/Button";
import Dialog from "components/organisms/Dialog/Dialog";
import { FormattedMessage, useIntl } from "react-intl";
import { resetWidgets } from "api";
import errorToast from "helpers/errorToast";

const ResetDashboardDialog = function ({ isShowing, close }) {
  const intl = useIntl();
  const [resetClicked, setResetClicked] = useState(false);

  const resetDashboard = () => {
    setResetClicked(true);
    localStorage.removeItem("dashboard_widgets");
    resetWidgets()
      .then(() => {
        localStorage.removeItem("rgl-8");
        window.location.reload();
      })
      .catch((err) => {
        setResetClicked(false);
        errorToast(
          err,
          intl.formatMessage({
            id: "dashboard.widgetToolbar.resetDashboardDialog.couldNotResetDashboard",
            defaultMessage: "Could not reset dashboard. Please try again later.",
          }),
        );
      });
  };

  return (
    <Dialog
      show={isShowing}
      title={intl.formatMessage({
        id: "dashboard.widgetToolbar.resetDashboardDialog.resetDashboard",
        defaultMessage: "Reset dashboard",
      })}
      onHide={close}
      size="md"
    >
      <Row className="mb-3">
        <Col className="pb-3">
          <p>
            <FormattedMessage
              id="dashboard.widgetToolbar.resetDashboardDialog.resetText"
              defaultMessage="Are you sure that you want to reset your dashboard?"
            />
          </p>
          <p className="mb-0 text-danger">
            <FormattedMessage
              id="dashboard.widgetToolbar.resetDashboardDialog.resetDescription"
              defaultMessage="All of your current widgets will be deleted."
            />
          </p>
        </Col>
      </Row>
      <div className="d-flex" style={{ marginTop: 16 }}>
        <Button
          className="rounded-pill font-b1"
          variant="outline-primary"
          label={intl.formatMessage({
            id: "general.cancel",
            defaultMessage: "Cancel",
          })}
          size="lg"
          onClick={close}
        />
        <Button className="ml-auto rounded-pill font-b1" size="lg" variant="danger" onClick={resetDashboard} type="submit">
          {" "}
          {resetClicked ? (
            <div className="spinner-border" role="status" />
          ) : (
            <FormattedMessage
              id="dashboard.widgetToolbar.resetDashboardDialog.resetWidget"
              defaultMessage="Yes, reset my dashboard"
            />
          )}
        </Button>
      </div>
    </Dialog>
  );
};

ResetDashboardDialog.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default ResetDashboardDialog;
